import React, { useContext } from "react";
import { LocalizationContext } from "../context/LocalizationContext";
import EventSourceList from "./EventSourceList";
import AlertBanner from "./AlertBanner";
import FormDetails from "./FormDetails";

function SelectEventSource() {
	const i18n = useContext(LocalizationContext);

	return (
		<div className="selecteventsource slds-p-around_medium slds-is-relative slds-size_1-of-1" style={{ height: "100vh" }}>
			<AlertBanner />
			<div className="slds-m-bottom_medium">
				<h2 className="slds-text-heading_large">{i18n.get('CHOOSE_SMART_CAPTURE_FORM')}</h2>
				<h3 className="slds-text-body_regular slds-m-top_x-small">{i18n.get('HEADLINE_HELP_BLOCK')}</h3>
			</div>
			<div className="slds-grid slds-wrap slds-gutters" style={{ height: "calc(100% - 80px)" }}>
				<div className="slds-col slds-size_3-of-4 slds-border_right" style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
					<EventSourceList />
				</div>
				<div className="slds-col slds-size_1-of-4 slds-p-left_medium" style={{ height: "100%", overflowY: "auto" }}>
					<FormDetails />
				</div>
			</div>
		</div>
	);
}

export default SelectEventSource;